export default {
  read: {
    title: "Perfil personal",
    subtitle: "Aquí puedes configurar tu perfil personal",
    steps: {
      products: "Productos",
      orders: "Pedidos"
    },
    form: {
      image: {
        label: "Imagen de perfil",
        help: "180x60, máx 25MB"
      },
      name: "Nombre",
      surname: "Apellidos",
      email: "Email",
      phone: "Teléfono",
      password: {
        label: "Cambiar contraseña",
        help: "Introduce tu nueva contraseña"
      },
      discountCode: "Código de descuento"
    }
  }
};
